export default "__VITE_ASSET__C4GsO1G9__"